import { DestroyRef, EventEmitter, inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class SearchInputService {
  private searchValue: string = '';
  searchTermSubject = new BehaviorSubject<string>(this.searchValue);
  clearSearchEvent: EventEmitter<void> = new EventEmitter<void>();

  private readonly router = inject(Router);
  private readonly destroy$ = inject(DestroyRef);

  private previousUrl: string = '';
  private currentUrl: string = '';

  constructor() {
    this.currentUrl = location.pathname;

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroy$),
    ).subscribe(() => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = location.pathname;
      if (this.previousUrl === this.currentUrl)
        return;
      if (this.searchValue)
        this.clearSearchTerm();
    });
  }

  set searchTerm(value: string) {
    this.searchValue = value;
    this.searchTermSubject.next(this.searchValue);
  }

  get searchTerm(): string {
    return this.searchTermSubject.value;
  }

  clearSearchTerm(): void {
    this.searchValue = '';
    this.searchTermSubject.next(this.searchValue);
  }
}
